import { Type } from '@sinclair/typebox';
import { PoolExtraDetailsSchema, PoolFromMigrationSchema, PoolSchemaExtended, PoolToMigrationSchema, } from '@blade/blockchain-types';
import { POOL_BLOCK_KEYS } from './pool-blocks.js';
/**
 * Runtime (typebox) block schemas for the ADDITIVE block-structured REST view.
 * Single-sourced from the same `POOL_BLOCK_KEYS` registry and `PoolSchemaExtended`
 * — no hand-maintained field lists. `Static<PoolBlocksViewSchema>` mirrors the TS
 * `PoolInfoUpdateBlocks` produced by `buildBlocksView`.
 *
 * The flat `PoolSchemaExtended` REST responses are unchanged — this is a separate,
 * opt-in projection.
 */
const FreshnessSchema = Type.Object({ updatedAt: Type.String() });
// Preserve the key literals (a widening cast would make Type.Pick pick every
// field). Generic K keeps each block's Static type accurate.
const pick = (keys) => Type.Pick(PoolSchemaExtended, [...keys]);
export const PoolInfoStaticBlockSchema = Type.Composite([
    FreshnessSchema,
    pick(POOL_BLOCK_KEYS.infoStatic),
    Type.Object({
        // extraDetails without `migration` (migration lives in the migration block)
        extraDetails: Type.Optional(Type.Omit(PoolExtraDetailsSchema, ['migration'])),
    }),
]);
export const PoolInfoMetricsBlockSchema = Type.Composite([
    FreshnessSchema,
    pick(POOL_BLOCK_KEYS.metrics),
]);
export const PoolInfoChartsBlockSchema = Type.Composite([
    FreshnessSchema,
    pick(POOL_BLOCK_KEYS.charts),
]);
export const PoolPremiumBlockSchema = Type.Composite([
    FreshnessSchema,
    pick(POOL_BLOCK_KEYS.premium),
]);
export const PoolMigrationBlockSchema = Type.Composite([
    FreshnessSchema,
    Type.Object({
        migrated: Type.Optional(Type.Boolean()),
        migration: Type.Optional(Type.Union([PoolToMigrationSchema, PoolFromMigrationSchema])),
    }),
]);
// Block-structured pool view (additive REST projection). Blocks are optional:
// premium/migration are data-gated, and a caller may request a subset.
export const PoolBlocksViewSchema = Type.Object({
    infoStatic: Type.Optional(PoolInfoStaticBlockSchema),
    metrics: Type.Optional(PoolInfoMetricsBlockSchema),
    charts: Type.Optional(PoolInfoChartsBlockSchema),
    premium: Type.Optional(PoolPremiumBlockSchema),
    migration: Type.Optional(PoolMigrationBlockSchema),
}, { title: 'PoolBlocksViewSchema' });
//# sourceMappingURL=pool-blocks-schema.js.map